import { FC, ReactNode } from 'react'

import { styled } from 'styled-components'

type ActionFooterProps = {
  leading?: ReactNode
  trailing: ReactNode
}

const ActionFooter: FC<ActionFooterProps> = ({ leading, trailing }) => (
  <Row>
    <Leading>{leading}</Leading>
    <Trailing>{trailing}</Trailing>
  </Row>
)

export default ActionFooter

const Row = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`

const Leading = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

const Trailing = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`
